<div class="px-11 bg-neutral-100">
  <app-top-hero-atom
    [brandText]="baseline"
    [links]="[
      { url: socialInstagramURL, icon: 'instagram' },
      { url: socialFacebookURL, icon: 'facebook' },
      { url: socialTiktokURL, icon: 'tiktok' },
      { url: socialLinkedinURL, icon: 'linkedin' },
    ]"
  ></app-top-hero-atom>
</div>
